var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"iframe",style:(_vm.cssHeight),attrs:{"src":_vm.url,"title":_vm.title,"frameborder":"0","width":"100%","height":_vm.height,"webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }